//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles((theme) => ({
    headerText: {
        textAlign: "left",
        font: "normal normal normal 1.5vw Segoe-ui",
        marginBottom: 0,
        letterSpacing: "0px",
        color: " #707070",
        fontSize: 28,
        display: "block",
        textAlign: "center",
    },
    // Burn
    headText: {
        fontSize: 20,
        fontWeight: "bold",
        fontFamily: "segoe-ui",
        letterSpacing: 1,
        "@media (max-width: 768px)": {
            textAlign: "center",
        },
    },
    inputsDiv: {
        padding: 15,
    },
    dateInput: {
        width: "90%",
    },
    numberInput: {
        width: "90%",
        marginTop:"16px"
    },
    filterInput: {
        width: "90%",
    },
    groupInput: {
        width: "90%",
    },
    appliedSpan: {
        color: "green",
        margin: "0px 10px",
        verticalAlign: "middle",
    },
    removeSpan: {
        fontSize: 14,
        backgroundColor: "red",
        color: "#fff",
        borderRadius: 10,
        padding: "2px 12px",
        margin: "0px 5px",
        verticalAlign: "middle",
        cursor: "pointer",
    },

    topGrid: {
        marginBottom: 20,
        display: "flex",
        alignItems: "center",
    },
    searchInput: {
        width: 400,
        borderRadius: 20,
        "@media (max-width: 600px)": {
            width: "100%",
        },
    },
    badge: {
        backgroundColor: "#C52025",
        color: "#fff",
        fontWeight: "bold",
    },
    filterBtn: {
        marginLeft: 20,
        alignSelf: "flex-end",
        backgroundColor: "#305698!important",
    },
    root: {},
    paper: {
        height: 140,
        width: 100,
    },
    control: {
        padding: theme.spacing(2),
    },
    input: {
        width: "30%",
        margin: "0 auto 0 1rem",
        "@media (max-width: 768px)": {
            width: "85%",
        },
    },
    // table
    paper: {
        width: "100%",
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    tableHeader: {
        background: "#EDEDED",
        boxShadow:
            "rgb(112 112 112 / 60%) 0px 1.5px 4px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 1px 0px, rgb(255 255 255) 0px -4px 0px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 0px 0px",
    },
    rowCell: {
        fontSize: 15,
        fontFamily: "segoe-ui",
        padding: "5px",
        border: "1px solid grey",
    },
    tableContainer: {
        overflowX: "unset",
    },
    tableHeading: {
        color: "#000",
        fontWeight: "bold",
        fontSize: 16,
        fontFamily: "segoe-ui !important",
        padding: 5,
        border: "1px solid",
        textAlign: "center",
    },
    groupByMarker: {
        color: "red",
        fontSize: 12,
    },
    noDisplay: {
        display: "none",
    },
    previewBtn: {
        color: "#305698!important",
        width: 150,
        height: 40,
        fontSize: 18,
        fontFamily: "segoe-ui",
        borderRadius: 5,
        textTransform: "capitalize",
        backgroundColor: "#fff",
        border: "2px solid #305698",
        margin: 10,
        outline: "none",
        "&:active": {
            outline: "none",
        },
        "&:focus": {
            outline: "none",
        },
    },
    exportBtn: {
        color: "#fff!important",
        width: 150,
        height: 40,
        fontSize: 18,
        fontFamily: "segoe-ui",
        borderRadius: 5,
        textTransform: "capitalize",
        backgroundColor: "#305698!important",
        margin: 10,
        outline: "none",
        lineHeight:1,
        "&:hover": {
            backgroundColor: "#305698!important",
        },
        "&:active": {
            outline: "none",
        },
        "&:focus": {
            outline: "none",
        },
    },
    exportAndPreview: {
        marginBottom: 100,
        "@media (max-width: 768px)": {
            display: "flex",
            justifyContent: "center",
        },
    },
    gridContainer: {
        padding: 20,
    },
    CSVlink: {
        display: "none",
    },
    mainDiv: {
        padding: 10,
        overflow: "auto",
        "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)":
        {
            height: "70vh",
        },
    },
    gridOne: {
        textAlign: "center",
        fontSize: 20,
        padding: 5,
        fontWeight: "bold",
    },
    gridTwo: {
        fontSize: 30,
        color: "Red",
        float: "right",
        cursor: "pointer",
    },
    gridThree: {
        fontSize: 18,
        padding: 10,
    },
    gridFour: {
        padding: 20,
        textAlign: "center",
    },
    gridFive: {
        textAlign: "right",
        fontSize: 18,
        padding: 10,
    },
    gridThreeSpan: {
        fontWeight: "bold",
    },
    tableHead: {
        background: "#EDEDED",
        boxShadow:
            "rgb(112 112 112 / 60%) 0px 1.5px 4px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 1px 0px, rgb(255 255 255) 0px -4px 0px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 0px 0px",
    },
    gridSix: {
        fontSize: 18,
        padding: 5,
    },
    dialogParentDiv: {
        padding: 25,
    },
    parentText: {
        fontSize: 18,
    },
    inputsDivselect: {
        padding: 15,
        fontWeight: "bold",
    },
    content :{
        fontSize:"85%",
        marginLeft:"2%",
        marginTop:"-1%"

    },

    selectbox:{
        width: "100%",
          padding: "10px 12px",
          border: "1px solid #ccc",
          borderRadious: "6px",
          marginBottom: "6px",
          fontSize: "14px"
    }


}));
